import axios from 'axios';

// Common Axios configurations
export const axiosConfig = {
  // Default timeout
  timeout: 10000,
  
  // Enable cookies for cross-origin requests
  withCredentials: true,
  
  // Default headers
  headers: {
    'Content-Type': 'application/json',
  },
  
  // Response type for different content types
  responseTypes: {
    json: 'json',
    blob: 'blob',
    text: 'text',
    arraybuffer: 'arraybuffer',
  },
};

// Helper function to create query string from object
export const createQueryString = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        // Join array values with commas instead of creating multiple parameters
        searchParams.append(key, value.join(','));
      } else {
        searchParams.append(key, String(value));
      }
    }
  });
  
  return searchParams.toString();
};

// Helper function to handle API errors
export const handleApiError = (error: any): string => {
  if (axios.isAxiosError(error)) {
    // Server responded with error status
    if (error.response) {
      const { status, data } = error.response;
      
      // Handle specific error statuses
      switch (status) {
        case 400:
          return data?.message || 'Bad request';
        case 401:
          return 'Unauthorized - please log in';
        case 403:
          return 'Forbidden - you don\'t have permission';
        case 404:
          return 'Resource not found';
        case 422:
          return data?.message || 'Validation error';
        case 500:
          return 'Server error - please try again later';
        default:
          return data?.message || `Error ${status}`;
      }
    }
    
    // Network error
    if (error.request) {
      return 'Network error - please check your connection';
    }
    
    // Other error
    return error.message || 'An unexpected error occurred';
  }
  
  return 'An unexpected error occurred';
};

// Helper function to create cancel token
export const createCancelToken = () => {
  return axios.CancelToken.source();
};

// Helper function to check if error is a cancel
export const isCancel = (error: any): boolean => {
  return axios.isCancel(error);
};
